import Dagre from "@dagrejs/dagre";
import _ from "lodash";

export const getLayoutedElements = (nodes, edges, options) => {
  const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));

  g.setGraph({
    rankdir: "TD",
    align: "UL",
    ranksep: 60,
    edgesep: 50,
  });
  let _nodes = _.cloneDeep(nodes);
  let _edges = _.cloneDeep(edges);

  _edges.forEach((edge) => g.setEdge(edge.source, edge.target));
  _nodes.forEach((node) =>
    g.setNode(node.id, _.omit(node, ["position", "x", "y", "rank"]))
  );

  Dagre.layout(g);

  return {
    nodes: _nodes.map((node) => {
      const { x, y } = g.node(node.id);

      return { ...node, position: { x, y } };
    }),
    edges: _edges,
  };
};
